// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bgb_a"};